import { Theme } from "@cloudscape-design/components/theming";

export const brandTheme: Theme = {
  tokens: {
    colorBorderDividerDefault: {
      light: "#1C4679",  
      dark: "#FFFFFF"
    },
    borderRadiusButton:"10",

    colorBorderContainerTop: {
      light: "#1C4679",  
      dark: "#FFFFFF"
    },
    colorBackgroundLayoutMain: {
      light: "#FFFFFF",  
      dark: "#FFFFFF"
    },
    colorBackgroundContainerContent: {
      light: "#FFFFFF",
      dark: "#FFFFFF"
    },
    colorTextLabel: {
      light: "#3376CC",  // Sustainable Green
      dark: "#397B26"
    },
    // Primary buttons in Sustainable Green
    colorBackgroundButtonPrimaryDefault: {
      light: "#1C4679",  // Sustainable Green
      dark: "#397B26"
    },
    colorBackgroundButtonPrimaryHover: {
      light: "#2d6b1e",  // Slightly darker green
      dark: "#2d6b1e"
    },
    colorTextButtonPrimaryDefault: {
      light: "#FFFFFF",
      dark: "#FFFFFF"
    },
    
    // Cancel/Secondary buttons in Energetic Orange
    colorBackgroundButtonNormalDefault: {
      light: "#FFFFFF",
      dark: "#FFFFFF"
    },
    colorBorderButtonNormalDefault: {
      light: "#397B26",
      dark: "#1C4679"
    },
    colorTextButtonNormalDefault: {
      light: "#397B26",
      dark: "#1C4679"
    },
    // Default link color
    colorTextLinkDefault: {
      light: "#3376CC",  
      dark: "#3376CC"
    },
    // Default link hiver color 
    colorTextLinkHover: {
      light: "#3376CC",  
      dark: "#3376CC"
    },

  },
};

